// Paleta de cores das páginas (0.65): segurar uma bolinha abre esta barrinha; a cor escolhida fica naquela bolinha.
import { useState } from 'react';
import { Modal, Pressable, ScrollView, Text, TextInput, View } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { C } from './theme';
import { N_, t } from '../lib/i18n';

export const GRUPOS_CORES: [string, string[]][] = [
  [N_('Básicas'), ['#111827', '#FFFFFF', '#DC2626', '#F97316', '#EAB308', '#16A34A', '#2563EB', '#7C3AED', '#DB2777', '#0891B2']],
  // verde militar, verde musgo, verde oliva, mostarda, terracota, vinho, azul petróleo, marrom, bege, cinza
  [N_('Neutras e opacas'), ['#4B5320', '#5B6B35', '#708238', '#C9A227', '#C0583A', '#7B1E3A', '#1F4E5F', '#6B4423', '#D9C7A7', '#6B7280']],
  [N_('Claras e pastel (boas para folha escura)'), ['#FDE68A', '#FBCFE8', '#DDD6FE', '#BFDBFE', '#BBF7D0', '#FED7AA', '#FECACA', '#A5F3FC', '#E5E7EB', '#F5F5F4']],
  [N_('Escuras (boas para folha clara)'), ['#1E3A8A', '#14532D', '#7F1D1D', '#4C1D95', '#78350F', '#134E4A', '#831843', '#1F2937', '#3F3F46', '#365314']],
];

// texto 20 (5): últimas cores usadas (ficam neste dispositivo)
const CHAVE_RECENTES = 'mp.cores.recentes';
let recentes: string[] = [];
AsyncStorage.getItem(CHAVE_RECENTES).then(v => { if (v) recentes = JSON.parse(v); }).catch(() => {});
const usou = (c: string) => {
  recentes = [c.toUpperCase(), ...recentes.filter(x => x.toUpperCase() !== c.toUpperCase())].slice(0, 10);
  AsyncStorage.setItem(CHAVE_RECENTES, JSON.stringify(recentes)).catch(() => {});
};

const hex = (s: string) => (/^#?[0-9a-f]{6}$/i.test(s.trim()) ? '#' + s.trim().replace('#', '').toUpperCase() : null);
/** Converte matiz (0-360), saturação e luz (0-1) em #RRGGBB. */
function hsl(h: number, s: number, l: number) {
  const k = (n: number) => (n + h / 30) % 12, a = s * Math.min(l, 1 - l);
  const f = (n: number) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  const x = (v: number) => Math.round(v * 255).toString(16).padStart(2, '0');
  return `#${x(f(0))}${x(f(8))}${x(f(4))}`.toUpperCase();
}

/** automatica (0.67.2): opção "Automática" no topo (ex.: Cor do desenho do tema decorativo). */
export function PaletaCores({ visivel, atual, onEscolher, onFechar, titulo, automatica }: { visivel: boolean; atual: string; onEscolher: (c: string) => void; onFechar: () => void; titulo?: string;
  automatica?: { on: boolean; desc?: string; onEscolher: () => void } }) {
  const [livre, setLivre] = useState(false);
  const [txt, setTxt] = useState(atual);
  const [matiz, setMatiz] = useState(200);
  const escolher = (c: string) => { usou(c); onEscolher(c); onFechar(); setLivre(false); };
  return (
    <Modal visible={visivel} transparent animationType="fade" onRequestClose={onFechar}>
      <Pressable onPress={onFechar} style={{ flex: 1, backgroundColor: C.overlay, justifyContent: 'flex-end' }}>
        <Pressable style={{ backgroundColor: C.card, borderTopLeftRadius: 22, borderTopRightRadius: 22, padding: 16, gap: 10, maxHeight: '80%' }}>
          <Text style={{ color: C.text, fontWeight: '800', fontSize: 16 }}>{titulo ?? t('Escolha a cor desta bolinha')}</Text>
          <ScrollView contentContainerStyle={{ gap: 12, paddingBottom: 20 }}>
            {!!automatica && (
              <Pressable onPress={() => { automatica.onEscolher(); onFechar(); setLivre(false); }} style={{ flexDirection: 'row', alignItems: 'center', gap: 10, padding: 10, borderRadius: 12,
                backgroundColor: C.card2, borderWidth: automatica.on ? 2 : 1, borderColor: automatica.on ? '#8B5CF6' : C.line }}>
                <Text style={{ fontSize: 20 }}>🌈</Text>
                <View style={{ flex: 1, gap: 2 }}>
                  <Text style={{ color: C.text, fontWeight: '700' }}>{t('Automática')}</Text>
                  {!!automatica.desc && <Text style={{ color: C.sub, fontSize: 12 }}>{automatica.desc}</Text>}
                </View>
                {automatica.on && <Text style={{ color: '#8B5CF6', fontWeight: '900' }}>✓</Text>}
              </Pressable>
            )}
            {recentes.length > 0 && (
              <View style={{ gap: 6 }}>
                <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700' }}>{t('Últimas cores usadas')}</Text>
                <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
                  {recentes.map(c => (
                    <Pressable key={'r' + c} onPress={() => escolher(c)} accessibilityLabel={c}
                      style={{ width: 34, height: 34, borderRadius: 17, backgroundColor: c, borderWidth: atual === c ? 3 : 1, borderColor: atual === c ? '#8B5CF6' : C.line }} />
                  ))}
                </View>
              </View>
            )}
            {GRUPOS_CORES.map(([nome, cores]) => (
              <View key={nome} style={{ gap: 6 }}>
                <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700' }}>{t(nome)}</Text>
                <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
                  {cores.map(c => (
                    <Pressable key={c} onPress={() => escolher(c)} accessibilityLabel={c}
                      style={{ width: 34, height: 34, borderRadius: 17, backgroundColor: c, borderWidth: atual === c ? 3 : 1, borderColor: atual === c ? '#8B5CF6' : C.line }} />
                  ))}
                </View>
              </View>
            ))}
            <Pressable onPress={() => setLivre(x => !x)}><Text style={{ color: C.text, fontWeight: '700' }}>🎨 {t('Escolher qualquer cor')} {livre ? '▾' : '▸'}</Text></Pressable>
            {livre && (
              <View style={{ gap: 8 }}>
                <View style={{ flexDirection: 'row', height: 30, borderRadius: 8, overflow: 'hidden' }}>
                  {Array.from({ length: 36 }, (_, i) => i * 10).map(h => (
                    <Pressable key={h} onPress={() => setMatiz(h)} style={{ flex: 1, backgroundColor: hsl(h, 0.85, 0.5), borderWidth: matiz === h ? 2 : 0, borderColor: '#fff' }} />
                  ))}
                </View>
                <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6 }}>
                  {[0.92, 0.82, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.12].flatMap(l => [0.9, 0.5, 0.2].map(s => hsl(matiz, s, l))).map((c, i) => (
                    <Pressable key={c + i} onPress={() => escolher(c)} style={{ width: 30, height: 30, borderRadius: 6, backgroundColor: c, borderWidth: 1, borderColor: C.line }} />
                  ))}
                </View>
                <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
                  <View style={{ width: 30, height: 30, borderRadius: 15, backgroundColor: hex(txt) ?? atual, borderWidth: 1, borderColor: C.line }} />
                  <TextInput value={txt} onChangeText={setTxt} autoCapitalize="characters" autoCorrect={false} placeholder="#3B82F6" placeholderTextColor={C.mute}
                    style={{ flex: 1, backgroundColor: C.card2, color: C.text, borderRadius: 10, paddingHorizontal: 12, paddingVertical: 8 }} />
                  <Pressable disabled={!hex(txt)} onPress={() => hex(txt) && escolher(hex(txt)!)} style={{ paddingHorizontal: 14, paddingVertical: 9, borderRadius: 10, backgroundColor: hex(txt) ? '#8B5CF6' : C.mute }}>
                    <Text style={{ color: '#fff', fontWeight: '700' }}>{t('Usar')}</Text>
                  </Pressable>
                </View>
              </View>
            )}
          </ScrollView>
        </Pressable>
      </Pressable>
    </Modal>
  );
}
